const palette = (lightDarkMode) => ({
  // mode: "dark",
  primary: {
    // light: will be calculated from palette.primary.main,
    main: "#3bbff0",
    // dark: will be calculated from palette.primary.main,
    // contrastText: will be calculated to contrast with palette.primary.main
  },
  secondary: {
    // light: will be calculated from palette.secondary.main,
    main: "#ffb629",
    // dark: will be calculated from palette.secondary.main,
  },
  success: {
    // light: will be calculated from palette.success.main,
    main: "#56d681",
    // dark: will be calculated from palette.success.main,
  },
  warning: {
    // light: will be calculated from palette.warning.main,
    main: "#ffb629",
    // dark: will be calculated from palette.warning.main,
  },
  info: {
    // light: will be calculated from palette.info.main,
    main: "#3bbff0",
    // dark: will be calculated from palette.info.main,
  },
  error: {
    // light: will be calculated from palette.error.main,
    main: "#ff5252",
    // dark: will be calculated from palette.error.main,
  },
  text: {
    primary: "#121212",
    secondary: "#909090",
  },
  // Used by `getContrastText()` to maximize the contrast between
  // the background and the text.
  contrastThreshold: 3,
  // Used by the functions below to shift a color's luminance by approximately
  // two indexes within its tonal palette.
  // E.g., shift from Red 500 to Red 300 or Red 700.
  tonalOffset: 0.2,
});

export default palette;
